import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackPixelEvent } from '../hooks/useMetaPixel';
interface CtaButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'compact';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  href?: string;
  className?: string;
}
export function CtaButton({
  children,
  variant = 'primary',
  size = 'lg',
  href = '#inversion',
  className = ''
}: CtaButtonProps) {
  const base = 'group inline-flex items-center justify-center gap-3 rounded-2xl text-center font-display font-extrabold uppercase leading-tight tracking-tight transition-[transform,background-color,box-shadow,color] duration-150 ease-calm focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-grass-300 active:translate-y-px';
  const sizes: Record<NonNullable<CtaButtonProps['size']>, string> = {
    sm: 'px-4 py-2.5 text-xs',
    md: 'px-6 py-3.5 text-sm',
    lg: 'px-8 py-4 text-base md:text-lg',
    xl: 'px-8 py-5 text-lg md:text-2xl'
  };
  const variants: Record<NonNullable<CtaButtonProps['variant']>, string> = {
    primary: 'bg-grass-500 text-white shadow-cta hover:bg-grass-600',
    secondary: 'bg-night text-white hover:bg-gray-800',
    compact: 'bg-grass-500 text-white hover:bg-grass-600'
  };
  const isCheckout = href.startsWith('http');
  const handleClick = () => {
    if (isCheckout) {
      trackPixelEvent('InitiateCheckout', {
        content_name: 'Protocollo Settembre Giallo',
        value: 19,
        currency: 'EUR'
      });
    }
  };
  return <a href={href} onClick={handleClick} className={`${base} ${sizes[size]} ${variants[variant]} ${className}`} data-id="element-41" data-mp="3swarwugj5zbr">
      <span data-id="element-42" data-mp="1lae37ewojcw">{children}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 ease-calm group-hover:translate-x-1 md:h-6 md:w-6" aria-hidden="true" data-id="element-43" data-mp="6ikc3bgd23cc" />
    </a>;
}